import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 */
export default class NewsSuggestionsValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {String} deps.literal
   * @param {Number} deps.model
   */
  constructor({config, literal, model}) {
    super({config, literal, model})

    this._config = config
    this._literal = literal
    this._model = model
  }

  /**
   * @return {Object}
   */
  toJSON() {
    return {
      content: this._literal,
      model: this._model
    }
  }
}
